export const SHOP_ADMINISTRATION_SHOPS_URL = `shop-administration/shops`;
